// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"47c10adf","57":"dfc50f12","124":"94e4099c","156":"7776d160","353":"0b5cb50e","449":"fe9a71c6","488":"66661e62","660":"dff304d2","697":"e157a719","712":"83d4c42d","888":"d9ea68be"}[chunkId] + ".chunk.js";
};